<script>
import Swal from "sweetalert2";
import store from "@/state/store"
import TitlePage from "@/components/title-page";
import creatInventoryDefault from "@/mixins/inventory/creatInventory"
import getListLocation from "@/mixins/items/getListLocation";

import { OtherService } from "@/services/other.service";
import { LocationService } from "@/services/nextshop/location.service";

export default {
  page: {
    title: "Thêm mới chi nhánh",
  },

  mixins: [creatInventoryDefault, getListLocation],

  components: {
    TitlePage
  },

  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      loading: false,
      idEmployee: "",
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentMerchant")),
      title: "THÊM MỚI CHI NHÁNH",
      items: [
        {
          text: "Quản lí chi nhánh",
          href: JSON.parse(localStorage.getItem("dataPermission")) && JSON.parse(localStorage.getItem("dataPermission")).includes('NSH_MCMNT_LOCATION_VIEW') ?
          "/location-list" : "#",
        },
        {
          text: "Thêm mới chi nhánh",
          active: true,
        },
      ],

      //upload IMG
      logoUrl: "",
      dropzoneFiles: [],
      dropzoneOptions: {
        url:
          "https://npa-api-gateway.nextshop.dev/s3/image?fileName=1633621539916&folder=nextshop",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
        maxFilesize: 2,
        maxFiles: 1,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
      },

      // list address
      listCity: [],
      listDistrict: [],
      listWard: [],

      // input
      // code: "",
      addressDetail: "",
      name: "",
      userName: "",
      password: "",
      isMainLocation: false,
      gender: "",
      phoneNo: "",
      email: "",
      description: "",
      city: "",
      district: "",
      address: "",
      codeError: "",
      //input
      idLocation: "",
      dataLocation: {
        city: null,
        district: null,
        ward: null,
      },
      nameMainLocation: "",
      errUpload: "",
      uploadImg: false,
      uploadFailed: false,
      modalShowLimit: false
    };
  },

  async created() {
    await this.getListCity();
    this.vmounted();
  },
  watch: {
    // check có muốn đổi cửa hàng chính k
    isMainLocation(newValue) {
      if (newValue) {
        this.getMainLocation().then(() => {
          Swal.fire({
            icon: "warning",
            title:
              '<a style="color:#3e69f6; font-size:24px; font-family:BeVietnam">Đổi cửa hàng chính</<a>',
            html: `<span style="color:#9093A4; font-size: 14px;" >Cửa hàng chính hiện tại là "${this.nameMainLocation}"</span><br/>
            <span style="color:#9093A4; font-size: 14px;">Bạn muốn đặt "${this.name}" làm cửa hàng chính</span>
            `,
            confirmButtonText: "Xác nhận",
          }).then((result) => {
            if (result.isConfirmed) {
              this.isMainLocation = true;
            } else this.isMainLocation = false;
          });
        });
      }
    },
  },
  methods: {
    // upload & remove & method IMG
    removeThisFile() {
      this.logoUrl = "";
      this.errUpload = "";
      this.dropzoneFiles = this.$refs.myVueDropzone.getAcceptedFiles();
      this.uploadFailed = false;
},

    async uploadImage(image) {
      try {
        this.uploadImg = true;
        const fd = new FormData();
        fd.append("image", image);
        const data = await OtherService.uploadImage(fd);
        if (data.success) {
          this.errUpload = "";
          this.logoUrl = data.data.imageLink;
          this.dropzoneFiles = this.$refs.myVueDropzone.getAcceptedFiles();
        }
      } catch (err) {
        console.log(err);
      }
    },

    async vmounted() {
      if (this.dataLocation.logoUrl) {
        const fileLogoStore = {
          name: `logoStore`,
          size: 2000000,
          type: "image/jpg",
          url: this.dataLocation.logoUrl,
        };
        this.dropzoneFiles.push(fileLogoStore);
        this.$refs.myVueDropzone.manuallyAddFile(
          fileLogoStore,
          this.dataLocation.logoUrl
        );
      }
    },

    // Update Img success
    updateSuccess() {
      this.uploadImg = false;
    },

    // fix mess erro of item
    failed(file, message) {
      const elements = document.querySelectorAll(".dz-error-message span");
      const lastElement = elements[elements.length - 1];
      this.uploadFailed = true;
      lastElement.textContent = message;
      if (file.size > 2000000) {
        lastElement.textContent = "Vượt quá dung lượng tối đa cho phép (2MB).";
        this.errUpload = "Vượt quá dung lượng tối đa cho phép (2MB).";
        this.uploadImg = false;
        Swal.fire({
          title: "Dung lượng ảnh quá lớn",
          text:
            "Dung lượng tối đa ảnh tải lên là 2MB (.PNG .JPG .JPEG .GIF). Vui lòng chọn ảnh khác.",
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
      } else {
        lastElement.textContent = "Ảnh không đúng định dạng";
        this.errUpload = "Ảnh không đúng định dạng.";
        this.uploadImg = false;
        Swal.fire({
          title: "Ảnh chọn sai định dạng",
          text: "Ảnh chọn sai định dạng (.PNG, .JPG). Vui lòng chọn ảnh khác.",
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
      }
    },
    successmsg(id) {
      Swal.fire({
        title: "Tạo mới thành công",
        text: `Đã tạo mới chi nhánh thành công!`,
        icon: "success",
        confirmButtonText: "Xác nhận",
      }).then(() => {
        this.$router.push({ path: `/location-list/location-detail/${id}` });
      });
    },


    // modal notitication
    modalNotification(code) {
      if (code == "MAX_LOCATIONS") {
        Swal.fire({
          icon: "error",
          title:
            '<a style="color:#f46a6a; font-size:20px; font-family:BeVietnam">Thông báo</<a>',
          html: `<span style="color:#9093A4; font-size: 14px;" >Số lượng chi nhánh đạt giới hạn</span>`,
          confirmButtonText: "Xác nhận",
          confirmButtonColor: "#DC2323",
        });
      } else if (code == "LOCATION_EXISTED") {
        Swal.fire({
          icon: "error",
          title:
            '<a style="color:#f46a6a; font-size:20px; font-family:BeVietnam">Thông báo</<a>',
          html: `<span style="color:#9093A4; font-size: 14px;" >Chi nhánh đã tồn tại</span>`,
          confirmButtonText: "Xác nhận",
          confirmButtonColor: "#DC2323",
        });
      } else {
        Swal.fire({
          icon: "error",
          title:
            '<a style="color:#f46a6a; font-size:20px; font-family:BeVietnam">Thông báo</<a>',
          html: `<span style="color:#9093A4; font-size: 14px;" >Không thêm mới được chi nhánh</span>`,
          confirmButtonText: "Xác nhận",
          confirmButtonColor: "#DC2323",
        });
      }
    },
    // list thành phố
    async getListCity() {
      try {
        this.listWard = [];
        const response = await OtherService.getlistCity();
        this.listCity = response.data.map((e) => {
          return {
            id: e.code,
            text: e.name,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    // quận huyện
    async getListDistrict({ id }) {
      this.listDistrict = [];
      const response = await OtherService.getlistDistrict({
        cityCode: id,
        countryCode: "vn",
      });
      if (response.success) {
        this.listDistrict = response.data.map((e) => {
          return {
            id: e.code,
            text: e.name,
          };
        });
      }
    },
    // phường xã
    async getListWard({ id }) {
      this.listWard = [];
      const response = await OtherService.getlistWard({
        cityCode: this.dataLocation.city.id,
        countryCode: "vn",
        districtCode: id,
      });
      if (response.success) {
        this.listWard = response.data.map((e) => {
          return {
            id: e.code,
            text: e.name,
          };
        });
      }
    },
    // Check cửa hàng chính
    async getMainLocation() {
      this.loading = true;
      try {
        const response = await LocationService.getMainLocation();
        if (response.success) {
          this.nameMainLocation = response.data.name;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    // Tạo mới location
    async creatLocation(validate) {
      validate().then(async (success) => {
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        } else {
          try {
            this.loading = true;
            const params = {
              address: this.address.trim(),
              // code: this.code ? this.code.trim() : null,
              description:
                this.description ? this.description.trim() : null,
              district: this.dataLocation.district
                ? this.dataLocation.district.text
                : null,
              districtCode: this.dataLocation.district
                ? this.dataLocation.district.id
                : null,
              isMainLocation: this.isMainLocation,
              name: this.name.trim(),
              onlineStoreUrl: `${process.env.VUE_APP_STORE_ONLINE}/store/${this.inforMerchant.aliasName}`,
              phoneNo: this.phoneNo != "" ? this.phoneNo.trim() : null,
              photoUrl: this.logoUrl != "" ? this.logoUrl : null,
              province: this.dataLocation.city
                ? this.dataLocation.city.text.trim()
                : null,
              provinceCode: this.dataLocation.city
                ? this.dataLocation.city.id.trim()
                : null,
              ward: this.dataLocation.ward
                ? this.dataLocation.ward.text.trim()
                : null,
              wardCode: this.dataLocation.ward
                ? this.dataLocation.ward.id.trim()
                : null,
              email: this.email != "" ? this.email.trim() : null,
            };
            const dataRes = await LocationService.creatLocation(params);

            if (dataRes.success) {
              const resLocation = await this.getListLocation()
              this.loading = false;
              const listLocations = resLocation.map(e => {
                return {
                  name: e.name,
                  id: e.coLocationId
                }
              })

              store.commit("auth/SET_lIST_LOCATIONS", listLocations);
              this.successmsg(dataRes.data.coLocationId);
            } else {
              if(dataRes.code == 'LOCATION_LIMITED' || dataRes.code == 'LOCATION_POLICY_CONFIG_LIMITED'){
                this.modalShowLimit = true
                this.loading = false;
              }else{
                this.loading = false;
                this.modalNotification(dataRes.code);
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
};
</script>

<template>
<TheLayout>
  <div v-if="dataPermission && dataPermission.includes('NSH_MCMNT_LOCATION_CREATE')">
    <ValidationObserver ref="observerProduct" v-slot="{ validate, invalid }">
      <b-form @submit.stop.prevent="creatLocation(validate)">
        <div class="box-loading" v-if="loading">
          <div class="loading">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12">
            <TitlePage :title="title" :items="items" class="mb-4" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <h5><b>Thông tin chi nhánh</b></h5>
            <p>Tên chi nhánh, địa chỉ , thông tin liên lạc của chi nhánh</p>
          </div>

          <div class="col-lg-8 pb-5 mb-5">
            <div class="card">
              <div class="card-body">
                <div class="createCustomerForm">
                  <div class="col-lg-12 dropzone-wrapper">
                    <div class="dropzone-main">
                      <Vue2Dropzone
                        id="dropzone"
                        ref="myVueDropzone"
                        :use-custom-slot="true"
                        :options="dropzoneOptions"
                        @vdropzone-file-added="uploadImage"
                        @vdropzone-mounted="vmounted"
                        @vdropzone-removed-file="removeThisFile"
                        @vdropzone-error="failed"
                        @vdropzone-queue-complete="updateSuccess">
                        <div class="dropzone-custom-content">
                          <i class="display-4 text-muted bx bx-cloud-upload"></i>
                        </div>
                      </Vue2Dropzone>
                    </div>

                    <div class="dropzone-text">
                      <p>Logo hoặc hình ảnh đại diện của chi nhánh</p>
                      <p>
                        Dung lượng tối đa tải ảnh lên là 2MB (.PNG .JPG .JPEG
                        .GIF)
                      </p>
                      <!-- <div
                        v-show="errUpload != ''"
                        class="is-invalid text-danger"
                      >
                        {{ errUpload }}
                      </div> -->
                      <!-- <b-button @click="addLinkImage()" variant="primary" class="w-lg">Tải ảnh lên</b-button> -->
                    </div>
                  </div>
                  <!-- Tên chi nhánh  -->
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-group label="" label-for="input-invalid">
                        <validation-provider
                          name="Tên chi nhánh"
                          rules="required|lBetween:1,255|CHECK_HTML"
                          v-slot="{ errors, valid }">
                          <label>Tên chi nhánh<sup class="text-danger"> * </sup></label>

                          <b-form-input
                            id="input-invalid"
                            type="text"
                            placeholder="Nhập tên chi nhánh"
                            v-model="name"
                            :state="errors[0] ? false : valid ? true : null"
                            @keydown.enter.prevent
                          />

                          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </validation-provider>
                      </b-form-group>
                    </div>
                    <!-- <div class="col-md-6">
                      <b-form-group label="" label-for="input-invalid">
                        <validation-provider
                          name="Mã chi nhánh"
                          rules="lBetween:6,12|CHECK_HTML"
                          v-slot="{ errors, valid }"
                        >
                          <label>Mã chi nhánh</label>

                          <b-form-input
                            id="input-invalid"
                            type="text"
                            placeholder="Nhập mã chi nhánh"
                            v-model.trim="code"
                            :state="errors[0] ? false : valid && code != '' ? true : null"
                            @keydown.enter.prevent
                          />

                          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </validation-provider>
                      </b-form-group>
                    </div> -->
                  </div>

                  <!-- Đặt làm cửa hàng chính -->
                  <!--<div class="d-flex align-items-center">
                    <switches
                      v-model="isMainLocation"
                      type-bold="false"
                      color="primary"
                      class="mb-0"
                    />
                    <p class="pl-2">Đặt làm chi nhánh mặc định</p>
                  </div>-->
                  <!-- Số điện thoại, Email  -->
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group label="" label-for="formrow-phone-input">
                        <validation-provider
                          name="Số điện thoại "
                          rules="required|max:15|PHONE_NO_3|CHECK_HTML"
                          v-slot="{ errors, valid }"
                        >
                          <label>Số điện thoại<sup class="text-danger"> * </sup></label>

                          <b-form-input
                            id="formrow-phone-input"
                            type="text"
                            v-model="phoneNo"
                            :state="errors[0] ? false : valid ? true : null"
                            @keydown.enter.prevent
                            placeholder="vd:0912345678"
                          />

                          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </validation-provider>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <b-form-group label="" label-for="formrow-email-input">
                          <validation-provider
                            name="Email"
                            rules="lBetween:6,255|EMAIL|CHECK_HTML"
                            v-slot="{ errors, valid }">
                            <label>Địa chỉ email</label>

                            <b-form-input
                              id="formrow-email-input"
                              type="text"
                              placeholder="Nhập địa chỉ email"
                              v-model="email"
                              :state="errors[0] ? false : valid && email != '' ? true : null"
                            />

                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                          </validation-provider>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <!-- Tỉnh/ Thành phố -->
                  <b-form-group
                    id="input-group-1"
                    label=""
                    label-for="formrow-inputField"
                  >
                    <label>Tỉnh/Thành phố</label>
                    <multiselect
                      v-model="dataLocation.city"
                      track-by="id"
                      label="text"
                      deselectLabel=""
                      selectLabel=""
                      selectedLabel=""
                      placeholder="Chọn Tỉnh/Thành phố"
                      :options="listCity"
                      :allow-empty="true"
                      @select="getListDistrict($event)"
                    >
                      <template slot="noOptions"> Chưa có dữ liệu </template>
                      <template slot="noResult">Không tìm thấy dữ liệu </template>
                    </multiselect>
                  </b-form-group>

                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group
                        id="input-group-1"
                        label=""
                        label-for="formrow-inputField"
                      >
                        <label>Quận/Huyện</label>

                        <multiselect
                          v-model="dataLocation.district"
                          track-by="id"
                          label="text"
                          deselectLabel=""
                          selectLabel=""
                          selectedLabel=""
                          placeholder="Chọn Quận/Huyện"
                          :options="listDistrict"
                          :allow-empty="true"
                          @select="getListWard($event)"
                        >
                          <template slot="noOptions">Chưa có dữ liệu</template>
                          <template slot="noResult">Không tìm thấy dữ liệu</template>
                        </multiselect>
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <b-form-group
                        id="input-group-1"
                        label=""
                        label-for="formrow-inputField"
                      >
                        <label>Phường/Xã</label>
                        <multiselect
                          v-model="dataLocation.ward"
                          track-by="id"
                          label="text"
                          deselectLabel=""
                          selectLabel=""
                          selectedLabel=""
                          placeholder="Chọn Phường/Xã"
                          :options="listWard"
                          :allow-empty="true"
                        >
                          <template slot="noOptions">Chưa có dữ liệu</template>
                          <template slot="noResult">Không tìm thấy dữ liệu</template>
                        </multiselect>
                      </b-form-group>
                    </div>
                  </div>

                  <!-- mô tả  -->
                  <b-form-group label="" label-for="formrow-address-input">
                    <validation-provider
                      name="Địa chỉ cụ thể"
                      rules="required|lBetween:3,255|CHECK_HTML"
                      v-slot="{ errors, valid }"
                    >
                      <label>Địa chỉ cụ thể<sup class="text-danger"> * </sup></label>

                      <b-form-textarea
                        v-model="address"
                        id="formrow-address-input"
                        class="form-control"
                        name="textarea"
                        rows="3"
                        placeholder="Nhập địa chỉ"
                        :state="errors[0] ? false : valid && address != '' ? true : null"
                      />

                      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                  <!-- chú thích -->
                  <b-form-group label="" label-for="formrow-description-input">
                    <validation-provider
                      name="Mô tả ngắn"
                      rules="lBetween:1,500|CHECK_HTML"
                      v-slot="{ errors, valid }"
                    >
                      <label>Mô tả ngắn</label>

                      <b-form-textarea
                        v-model="description"
                        id="formrow-description-input"
                        class="form-control"
                        name="textarea"
                        rows="3"
                        placeholder="Thêm mô tả"
                        :state="errors[0] ? false : valid && description != '' ? true : null"
                      />

                      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-custom">
          <div class="d-flex justify-content-end bg-white px-1">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="invalid || uploadImg || uploadFailed"
            >
              Xác nhận thông tin
            </button>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
    <b-modal v-model="modalShowLimit" hide-footer centered no-close-on-backdrop id="modalShowLimit">
        <template #modal-header>
          <h1 class="fz-18 mb-0"><b>Không thể tạo chi nhánh</b></h1>
          <button type="button" aria-label="Close" class="close close-ext pb-0 pt-3"
            @click="modalShowLimit=false">×</button>
        </template>
        <div class="text-center">
          <div><img src="@assets/images/danger.png"></div>
          <div class="text-message">Không thể tạo thêm chi nhánh do số chi nhánh đã đạt đến giới hạn gói NextShop của bạn.</div>
        </div>
        <div class="text-button-message">
          <el-button type="primary" @click="modalShowLimit=false">Đồng ý</el-button> 
        </div>
      </b-modal>
  </div>
  <NotPermission v-else></NotPermission>
</TheLayout>
</template>
<style scoped>
  .text-message {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .text-button-message {
  text-align: right;
  border-top: 1px solid #ddd;
  padding-top: 20px;
}
</style>